import React, { useState } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Cloudinary, transformationStringFromObject } from "@cloudinary/url-gen";
import { AdvancedImage, lazyload, responsive } from "@cloudinary/react";
import * as styles from "./CloudinaryImage.module.scss";

const CloudinaryImage = ({ alt, cloudinary }) => {
	const [isLoaded, setIsLoaded] = useState(false);

	const cld = new Cloudinary({
		cloud: {
			cloudName: "dtnwfag6s",
		},
		url: {
			privateCdn: true,
			secureDistribution: "assets.vacationvaults.ca",
			secure: true,
			analytics: false,
		},
	});

	const myImage = cld.image(cloudinary.public_id).addTransformation(
		transformationStringFromObject([
			{
				raw_transformation: cloudinary.raw_transformation,
			},
			{
				crop: "lfill",
				dpr: "auto",
				aspect_ratio: cloudinary.aspectRatio,
				width: "auto",
			},
		])
	);

	return (
		<div className={cx(!cloudinary.adoptHeight && styles.container)}>
			<div
				style={{
					paddingBottom: `${(1 / cloudinary.aspectRatio) * 100}%`,
				}}
			/>
			<AdvancedImage
				className={cx(styles.image, isLoaded && styles.loaded)}
				cldImg={myImage}
				alt={alt}
				onLoad={() => {
					setIsLoaded(true);
				}}
				plugins={[lazyload(), responsive()]}
			/>
		</div>
	);
};

CloudinaryImage.propTypes = {
	alt: PropTypes.string,
	cloudinary: PropTypes.shape({
		public_id: PropTypes.string,
		width: PropTypes.number,
		height: PropTypes.number,
		version: PropTypes.number,
		raw_transformation: PropTypes.string,
		aspectRatio: PropTypes.number,
		adoptHeight: PropTypes.bool,
	}).isRequired,
};

CloudinaryImage.defaultProps = {
	alt: "",
};

export default CloudinaryImage;
export { CloudinaryImage };
